import { BASE_API_URL_V2 } from "@/constants";
import store from "@/redux/store";
import fpFetch from "@/services/fpFetch";
import { Editor } from "@tiptap/react";
import { setProductTimeout } from "@/utils/productTimers";

const exportToPDF = async (
  editor: Editor,
  title?: string,
  includeLinks: boolean = true
) => {
  // Get workspace ID from editor state
  const workspaceId = store.getState().fpAppV4Data.workspaceId;
  if (!workspaceId) {
    throw new Error("No workspace ID found");
  }

  try {
    // Make request to backend endpoint with includeLinks parameter
    const response = await fpFetch(
      `${BASE_API_URL_V2}/api/v2/workspace/${workspaceId}/pdf?include_links=${includeLinks}`
    );

    if (!response.ok) {
      throw new Error(`Export failed: ${response.statusText}`);
    }

    // Get filename from Content-Disposition header
    const contentDisposition = response.headers.get("Content-Disposition");
    if (!contentDisposition) {
      throw new Error("No Content-Disposition header found in response");
    }

    // Parse filename, keeping the quotes to preserve spaces and special characters
    const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
    if (!filenameMatch || !filenameMatch[1]) {
      throw new Error("Invalid Content-Disposition header format");
    }
    const filename = filenameMatch[1];

    // Get blob directly
    const blob = await response.blob();

    // Create and trigger download
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    // Cleanup after a short delay to ensure download starts
    setProductTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 100);
  } catch (error) {
    console.error("PDF export failed:", error);
    throw error;
  }
};

export default exportToPDF;
